type Listener = () => void;

const listeners = new Set<Listener>();
let activeCount = 0;
let graceUntil = 0;

function emit(): void {
  for (const listener of listeners) listener();
}

export function beginOperatorExternalActivity(): () => void {
  activeCount += 1;
  emit();
  let ended = false;
  return () => {
    if (ended) return;
    ended = true;
    activeCount = Math.max(0, activeCount - 1);
    graceUntil = Math.max(graceUntil, Date.now() + 5_000);
    emit();
  };
}

export async function withOperatorExternalActivity<T>(
  action: () => Promise<T>,
): Promise<T> {
  const end = beginOperatorExternalActivity();
  try {
    return await action();
  } finally {
    end();
  }
}

export function operatorExternalActivityActive(now = Date.now()): boolean {
  return activeCount > 0 || graceUntil > now;
}

export function subscribeOperatorExternalActivity(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function resetOperatorExternalActivityForTests(): void {
  activeCount = 0;
  graceUntil = 0;
  emit();
}
